import kamala from '../../kamala'
import TooltipAction from './TooltipAction'

TooltipAction.install = function (Vue) {
  kamala(Vue)

  Vue.component(TooltipAction.name, TooltipAction)
}

export default TooltipAction
